import { Box } from '@mui/material'
import React from 'react'
import { Transition } from 'react-transition-group'

import Spinner from 'components/common/Spinner'
import Text from 'components/common/Text'
import theme from 'theme'

type LoadingTextProps = {
  text: string
  index: number
}

const LoadingText: React.FC<LoadingTextProps> = ({ text, index = 0 }) => (
  <Text
    as="h4"
    css={{
      textAlign: 'center',
      position: 'absolute',
      color: theme.colors.steel[1],
      top: '50%',
      left: '50%',
      transform: `translate(-50%, ${index + 1}00%)`
    }}
  >
    {text}
  </Text>
)

interface BusyOverlayProps {
  shown?: boolean
  className?: string
  text?: string | string[]
  transparentBg?: boolean
  rounded?: boolean
}

const BusyOverlay: React.FC<BusyOverlayProps> = ({
  shown,
  text,
  transparentBg,
  rounded,
  ...rest
}) => {
  const textStrings = typeof text === 'string' ? [text] : text

  return (
    <Transition in={shown} timeout={300}>
      {(state) => {
        return (
          <Box
            data-test-busy-overlay
            sx={{
              position: 'absolute',
              top: '0',
              left: '0',
              right: '0',
              bottom: '0',
              backgroundColor: transparentBg
                ? 'transparent'
                : 'rgba(255, 255, 255, 0.95)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              pointerEvents: 'none',
              height: '100%',
              maxHeight: '100vh',
              transition: 'opacity 500ms ease-in',
              opacity: Number(state === 'entering' || state === 'entered'),
              zIndex: theme.zIndices[2],
              borderRadius: rounded ? theme.borderRadius[0] : null
            }}
            {...rest}
          >
            <Spinner data-test-loading-spinner size={36} />
            {text &&
              textStrings?.map((line, index) => (
                <LoadingText key={line} index={index} text={line} />
              ))}
          </Box>
        )
      }}
    </Transition>
  )
}

export default BusyOverlay
